import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgPyf = function SvgPyf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.338 8.667H.69c.055-.264.114-.528.177-.792 0 0 1.028-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 4.447 1.728 5.476 6.646 5.476 6.646.06.252.118.505.17.758ZM.682 23.333H31.31a29.56 29.56 0 0 1-.177.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124a25.83 25.83 0 0 1-.184-.79Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.686 21.537c.196-.105.419-.19.642-.203h.062c.675 0 .862.574 1.33.62.469.046.86-.576 1.441-.599.31-.012.665.133.927.272A5.989 5.989 0 0 1 16 22a5.98 5.98 0 0 1-2.314-.463Zm-2.27-1.665c.183-.116.368-.205.518-.205.433 0 .83.626 1.282.667.452.042.723-.626 1.32-.626.596 0 .94.606 1.409.606.47 0 .958-.564 1.427-.585.47-.02.94.605 1.356.585.415-.021.776-.606 1.283-.627.19.02.386.096.56.199-.24.283-.506.543-.795.777l-7.59-.031a6.034 6.034 0 0 1-.77-.76Zm9.574-.539H19s.456-.36.58-.694c.229.167.167.333.623.361.456.028.89-.692 1.326-.666-.148.352-.33.686-.54 1Zm-10.515-.989c.415.088.831.681 1.265.656.478-.028.413-.194.652-.36.13.332.608.693.608.693h-1.99a5.985 5.985 0 0 1-.535-.989Zm4.527.99c-.033 0 .385-.972.999-.997.551-.074 1.014.97.999.994l-1.998.002Z",
    fill: "#2C97DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.21 14.419c.118-.431.282-.843.487-1.23L14 15.668v.13l-3.79-1.378Zm-.14.658 3.93 1.43v.16h-3.963a6.065 6.065 0 0 1 .033-1.59Zm1.73-3.362 2.2 2.828v.29l-2.956-2.216c.223-.325.476-.627.756-.902Zm.502-.44A5.988 5.988 0 0 1 14 10.34v3.116l-1.698-2.183Zm9.488 3.144L18 15.797v-.13l3.302-2.477c.206.386.37.798.488 1.229Zm.14.658a6.049 6.049 0 0 1 .033 1.59H18v-.16l3.93-1.43Zm-1.73-3.362c.28.275.533.577.756.902L18 14.833v-.29l2.2-2.828Zm-.502-.44L18 13.457v-3.116c.619.22 1.19.536 1.698.934Z",
    fill: "#E87E04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.167 12.667H12.5v4.916a1.417 1.417 0 0 0 2.833.017 1.25 1.25 0 0 1-2.166-.85v-4.083Zm5.5 0h.666v4.916a1.417 1.417 0 0 1-2.833.017 1.25 1.25 0 0 0 2.167-.85v-4.083Zm-1.501-2.474V10a2.5 2.5 0 0 0-2.5 2.5v2.333l2.5.834V12.14c-.08.017-.163.027-.25.027-.598 0-1.083-.448-1.083-1 0-.553.485-1 1.083-1 .087 0 .17.009.25.026Z",
    fill: "#E94B35"
  }));
};

export default SvgPyf;